import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51e34b5c")

_pushScopeId("data-v-51e34b5c")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "progress mt-3" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-3" }, null, -1)
const _hoisted_5 = {
  class: "col-lg-6 col-md-6 col-sm-12 col-12 alert alert-warning m-2",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", { class: "alert-heading" }, "Message:", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "col-3" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "progress-bar ",
          role: "progressbar",
          style: `width: ${33.33 * _ctx.step}%`
        }, null, 4)
      ]),
      (_ctx.showMessage)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("p", null, _toDisplayString(_ctx.userProfile.comments), 1)
            ]),
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_8,
    _createVNode(_component_router_view)
  ], 64))
})